import React, { useEffect } from 'react';
import { CampaignManager } from './CampaignManager';
import { useData } from '../../../data-layer';

export function Campaigns(): JSX.Element {
  const { campaigns, sponsors } = useData();

  // Sponsors back the sponsor picker on CampaignForm.
  useEffect(() => {
    campaigns.hook.getAll();
    sponsors.hook.getAll();
  }, []);

  return <CampaignManager />;
}
